import { useNavigate } from 'react-router';
import Stack from '@mui/material/Stack';
import { BlurContainer, JuicyTypography } from '../../components/index.ts';
import { type StackProps, Typography, useTheme } from '@mui/material';
import { ConvertIcon } from '../../assets/icons/convert.tsx';
import { NextPageButton } from '../../components/button/NextPageButton.tsx';
import { PlayerIcon } from '../../assets/icons/player.tsx';
import { Path } from '../../assets/enums/index.ts';
import { useGameSessionContext } from '../../assets/helpers/hooks/index.ts';
import { containerSx, getStackSx } from './styles.ts';
import { PageBackButton } from '../../components/button/pageBackButton.tsx';
import * as React from 'react';

export const StartGamePage = () => {
  const { gameSessionParams } = useGameSessionContext();
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Stack height={'100%'} gap={10} pb={14}>

      <BlurContainer sx={containerSx}>
        {gameSessionParams.phoneNumber &&
          <Stack sx={getStackSx(theme)}>
            <PlayerIcon />
            <Typography variant={'body'}>{gameSessionParams.phoneNumber}</Typography>
          </Stack>
        }

        <JuicyTypography>{gameSessionParams.gameName}</JuicyTypography>

        {!gameSessionParams.isFreeTraining &&
          <Stack direction="row" alignItems="center" gap={8.5} width={'100%'}>
            <GamePrice title={'Your Wager'} amount={Number(gameSessionParams.amount)} />
            <ConvertIcon style={{ minWidth: '24px' }} />
            <GamePrice title={'Prize Money'} amount={Number(gameSessionParams.amount) * gameSessionParams.factor} />
          </Stack>
        }
      </BlurContainer>

      <Stack width="100%" direction={'row'} alignItems={'center'} gap={8} mt={20}>
        <PageBackButton onClick={() => navigate(Path.GameSettings)} />
        <NextPageButton onClick={() => navigate(Path.Game)}>Take Your Shot</NextPageButton>
      </Stack>



    </Stack>
  );
};

type GamePricePT = {
  title: string;
  amount: number;
} & StackProps;

const GamePrice = ({ title, amount, ...rest }: GamePricePT) => {
  return (
    <Stack alignItems="cetner" gap={2} width={'100%'} textAlign={'center'}{...rest}>
      <JuicyTypography mt={4} variantStyle={'orange'} variant={'subtitle'}>{title}</JuicyTypography>
      <JuicyTypography mt={4} variantStyle={'orange'}>${amount}</JuicyTypography>
    </Stack>
  );

};